/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState, useRef} from "react";
import PropTypes from "prop-types";
import {handleAuthentication} from "api";

import {
  WealthyValidations,
  triggerToast,
  handleFuryApiError,
  getRSessionId
} from "helpers";

import UserCredentials from "./UserCredentials";

const propTypes = {
  rCode: PropTypes.string,
  resetPin: PropTypes.bool,
  setAuthRes: PropTypes.func,
  setIsLoading: PropTypes.func,
  setRsessionId: PropTypes.func,
  setUserData: PropTypes.func,
  setUserStep: PropTypes.func,
  userData: PropTypes.object
};

const UserCredentialsContainer = ({
  userData,
  setUserData,
  setAuthRes,
  setUserStep,
  setRsessionId,
  setIsLoading,
  rCode,
  resetPin
}) => {
  const [captcha, setCaptcha] = useState("");
  const recaptchaRef = useRef();

  const handleInput = (e, type) => {
    userData[type] = e.target.value;
    setUserData(userData);
  };

  const handleRecaptchaToken = (token) => {
    setCaptcha(token);
  };

  const handleCredentials = async () => {
    setIsLoading(true);
    const nameCheck = WealthyValidations.validateFormField.name(userData.name || "");
    const phoneCheck = WealthyValidations.validateFormField.phone(userData?.phone_number || "");
    if (!nameCheck) {
      triggerToast("Enter correct name!", "error");
      setIsLoading(false);
    }
    if (!phoneCheck) {
      triggerToast("Enter valid phone number!", "error");
      setIsLoading(false);
    }
    if (captcha !== "") {
      if (nameCheck && phoneCheck) {
      // const captcha = await recaptchaRef.current.execute();
        userData["g-recaptcha-response"] = captcha;
        setUserData(userData);
        const rSessionId = getRSessionId();
        setRsessionId(rSessionId);
        try {
          const res = await handleAuthentication(userData, rCode, rSessionId);
          if (res?.data) {
            setUserStep(2);
            setIsLoading(false);
            setAuthRes(res.data);
          } else {
            setIsLoading(false);
          }
        } catch (err) {
          handleFuryApiError(err);
          setIsLoading(false);
        }
      }
    } else {
      triggerToast("Verify Captcha", "error");
      setIsLoading(false);
    }
  };

  return (
    <UserCredentials
      handleCredentials={handleCredentials}
      handleInput={handleInput}
      handleRecaptchaToken={handleRecaptchaToken}
      resetPin={resetPin}
      // recaptchaRef={recaptchaRef}
      setUserStep={setUserStep}
    />
  );
};

UserCredentialsContainer.propTypes = propTypes;

export default UserCredentialsContainer;
